import QLC_ICON from 'src/features/notifications/assets/qlc-hori.png'

type LeadInquiryIconProps = {
  mapSnapshot: string
}

const LeadInquiryIcon = ({ mapSnapshot }: LeadInquiryIconProps) => {
  if (!mapSnapshot) {
    return (
      <div className="relative flex size-[49px] items-center justify-center rounded-[10px] border-2 border-white bg-background shadow-[0_2px_12px_rgba(27,48,41,0.1)]">
        <img src={QLC_ICON} alt="qlc icon" className="size-[32px] object-contain" />
      </div>
    )
  }

  return (
    <div className="relative flex size-[49px] items-center justify-center rounded-[10px] border-2 border-white bg-background shadow-[0_2px_12px_rgba(27,48,41,0.1)]">
      <img src={mapSnapshot} alt="lead inquiry" className="size-full rounded-[10px] bg-lightBorder object-cover" />
    </div>
  )
}

export default LeadInquiryIcon
